export default "__VITE_ASSET__CrU80q_U__"